import React, { useEffect } from "react";
import { DropdownMenu } from "@/components/ui/dropdown-menu";
import { DropdownMenuContent } from "@/components/ui/dropdown-menu";
import { DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { LanguageMenuProps } from "./types";
import { supportedLngs, changeLanguage, getCurrentLanguage } from "../lib/i18n";

export const LanguageMenu: React.FC<LanguageMenuProps> = ({
  languages,
  onLanguageChange,
}) => {
  const itemClass = "my-[8px] rounded-lg p-[8px]";
  const itemUnselected =
    "bg-secondary focus:bg-secondary focus:text-secondary-foreground";
  const itemSelected =
    "bg-softWhite text-softWhite-foreground focus:bg-softWhite focus:text-softWhite-foreground";
  const [selectedLanguage, setSelectedLanguage] = React.useState("en-gb");

  useEffect(() => {
    const currentLanguage = getCurrentLanguage();
    setSelectedLanguage(currentLanguage);
  }, []);

  // Event handler to update state when a language option is selected
  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    changeLanguage(lang);
    if (onLanguageChange) {
      onLanguageChange(lang);
    }
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="mr-[16px] md:mr-[24px]">
        <div
          className="mr-[-16px] md:mr-[-24px] pointer-events-auto flex items-end gap-[8px] h-full"
          aria-label="Language menu"
        >
          <img
            src="/assets/img/buttonLang.svg"
            alt="Change language"
            className="object-contain h-[20px] w-auto"
          />
          <span className="text-sm md:text-md ">
            {supportedLngs[selectedLanguage] || "English"}
          </span>
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="bg-background rounded-lg border-tertiary px-[8px] mr-0 md:mr-[-10px]"
        sideOffset={8}
      >
      {Object.keys(supportedLngs).map((lang) => {
        return (
          <DropdownMenuItem
            key={lang}
            id={lang}
            onClick={() => handleLanguageChange(lang)}
            className={`${itemClass} ${
              selectedLanguage === lang ? itemSelected : itemUnselected
            }`}
          >
            {supportedLngs[lang]}
          </DropdownMenuItem>
        );
      })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
